import React from 'react';
import {
  Zap,
  SkipForward,
  DollarSign,
  Clock,
  Navigation,
  Filter,
  Trophy,
  Shield,
} from 'lucide-react';

export const Features = () => {
  const features = [
    {
      icon: Zap,
      title: 'Auto Accept & Auto Skip',
      description:
        'Terima atau lewati pesanan secara otomatis berdasarkan preferensi Anda',
    },
    {
      icon: DollarSign,
      title: 'Filter Harga Pintar',
      description:
        'Atur harga minimum dan filter pesanan yang tidak menguntungkan',
    },
    {
      icon: SkipForward,
      title: 'Auto Up Price',
      description:
        'Naikkan harga otomatis 1x / 2x / 3x dengan kontrol persentase',
    },
    {
      icon: Clock,
      title: 'Pemilihan Waktu Otomatis',
      description:
        'Pilih waktu penjemputan terbaik secara otomatis',
    },
    {
      icon: Navigation,
      title: 'Mode Arrive Quickly',
      description:
        'Optimasi untuk sampai ke lokasi penjemputan lebih cepat',
    },
    {
      icon: Filter,
      title: 'Filter Area, Jarak & Rating',
      description:
        'Tentukan area kerja, jarak maksimal, dan rating penumpang',
    },
    {
      icon: Trophy,
      title: 'Leaderboard Penghasilan',
      description:
        'Pantau penghasilan Anda dan bandingkan dengan driver lain',
    },
    {
      icon: Shield,
      title: 'Anti-Hack & Device ID',
      description:
        'Perlindungan akun dengan sistem Device ID yang aman',
    },
  ];

  return (
    <section
      id="features"
      style={{
        background: 'var(--bg-primary)',
        padding: '100px 7.6923%',
      }}
    >
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2
            style={{
              fontSize: '48px',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.02em',
              color: 'var(--text-primary)',
              marginBottom: '16px',
            }}
          >
            Fitur Unggulan BAiBOT
          </h2>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.5,
              color: 'var(--text-secondary)',
            }}
          >
            Otomasi lengkap untuk meningkatkan penghasilan driver inDriver
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
          }}
          className="features-grid"
        >
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="dark-hover"
                style={{
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-subtle)',
                  padding: '32px',
                  transition: 'all 0.4s ease-in-out',
                }}
              >
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    background: 'var(--brand-hover)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '24px',
                  }}
                >
                  <Icon size={28} color="var(--brand-primary)" />
                </div>
                <h3
                  style={{
                    fontSize: '24px',
                    fontWeight: 600,
                    lineHeight: 1.3,
                    color: 'var(--text-primary)',
                    marginBottom: '12px',
                  }}
                >
                  {feature.title}
                </h3>
                <p
                  style={{
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: 1.4,
                    color: 'var(--text-secondary)',
                  }}
                >
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <style>
        {`
          @media (max-width: 767px) {
            .features-grid {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};